export const getIdFromText = (text: string) => {
  if (!text) {
    return '';
  }

  return text
    .toLowerCase()
    .replaceAll(/[^a-z0-9]+/g, '-')
    .replaceAll(/^-+|-+$/g, '');
};
